const Window = props => (
  <svg {...props} width="24px" height="6px" viewBox="0 0 24 6" version="1.1">
    <g id="FPCBuilder" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" transform="translate(-690.000000, -101.000000)">
      <g id="WIndow" transform="translate(690.000000, 101.000000)">
        <rect id="Rectangle-16" fill="#DBDEE0" x="0" y="0" width="24" height="6"></rect>
        <path d="M0,2.83333333 L24,2.83333333" id="Line-5" stroke="#313F4C" strokeWidth="1.5"></path>
      </g>
    </g>
  </svg>
);

export default Window;
